import React, { Component } from "react";
import styles from "./../reportTable.module.scss";
import Scrollbars from "react-custom-scrollbars-2";
import GeoZoneByDayHeader from "./GeoZoneByDayHeader";
import GeoZoneByDayContent from "./GeoZoneByDayContent";

class GeoZoneByDay extends Component {
  render() {
    const { reportData, height = 450 } = this.props;

    if (reportData.geoZoneViewModel === null) return <div></div>;

    return (
      <div>
        <GeoZoneByDayHeader />
        <Scrollbars style={{ height: height + "px" }} autoHide={false} ref="scrollbar">
          {reportData.geoZoneViewModel.geoZones.map((geoZone, index) => {
            return <GeoZoneByDayContent key={index} geoZone={geoZone} />;
          })}
        </Scrollbars>
      </div>
    );
  }
}

export default React.memo(GeoZoneByDay);
